//皮肤色管理:pileColor单一来源,运行时注入覆盖样式驱动按钮/横幅实时换肤
const DEFAULT_SKIN = '#337537'

//统一6位hex,非法回落默认皮肤
function normalize(hex){
  if(typeof hex !== 'string') return DEFAULT_SKIN
  let m = hex.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
  if(!m) return DEFAULT_SKIN
  let v = m[1]
  if(v.length === 3) v = v.split('').map(c => c + c).join('')
  return '#' + v.toLowerCase()
}

function hexToRgb(hex){
  return [
    parseInt(hex.slice(1,3),16),
    parseInt(hex.slice(3,5),16),
    parseInt(hex.slice(5,7),16)
  ]
}

function rgbToHex(r,g,b){
  return '#' + [r,g,b].map(v => ('0' + Math.round(v).toString(16)).slice(-2)).join('')
}

//hex转hsl,返回[h,s,l]均0-1
function hexToHsl(hex){
  let rgb = hexToRgb(hex).map(v => v/255)
  let max = Math.max(rgb[0],rgb[1],rgb[2]), min = Math.min(rgb[0],rgb[1],rgb[2])
  let h = 0, s = 0, l = (max+min)/2
  if(max !== min){
    let d = max - min
    s = l > 0.5 ? d/(2-max-min) : d/(max+min)
    if(max === rgb[0]) h = (rgb[1]-rgb[2])/d + (rgb[1] < rgb[2] ? 6 : 0)
    else if(max === rgb[1]) h = (rgb[2]-rgb[0])/d + 2
    else h = (rgb[0]-rgb[1])/d + 4
    h /= 6
  }
  return [h,s,l]
}

function hslToHex(h,s,l){
  const f = t => {
    t = t < 0 ? t+1 : t > 1 ? t-1 : t
    let q = l < 0.5 ? l*(1+s) : l+s-l*s, p = 2*l-q
    let c = t < 1/6 ? p+(q-p)*6*t : t < 1/2 ? q : t < 2/3 ? p+(q-p)*(2/3-t)*6 : p
    return Math.round(c*255)
  }
  return rgbToHex(f(h+1/3), f(h), f(h-1/3))
}

//亮度增减,pct>0提亮
function shade(hex, pct){
  let hsl = hexToHsl(hex)
  return hslToHex(hsl[0], hsl[1], Math.min(1, Math.max(0, hsl[2]+pct)))
}

//混白,ratio为白色占比0-1
function mixWhite(hex, ratio){
  let rgb = hexToRgb(hex)
  return rgbToHex(rgb[0]+(255-rgb[0])*ratio, rgb[1]+(255-rgb[1])*ratio, rgb[2]+(255-rgb[2])*ratio)
}

export function getSkin(){
  return normalize(localStorage.getItem('pileColor'))
}

//注入全站覆盖样式:按钮各态与横幅渐变,换肤时重复调用即时生效
export function applySkin(color){
  let c = normalize(color)
  let style = document.getElementById('pile-skin-style')
  if(!style){
    style = document.createElement('style')
    style.id = 'pile-skin-style'
    document.head.appendChild(style)
  }
  let hover = shade(c, 0.08),
      active = shade(c, -0.08),
      disabled = mixWhite(c, 0.5),
      plainBg = mixWhite(c, 0.9),
      plainBorder = mixWhite(c, 0.7),
      plainDisabled = mixWhite(c, 0.55),
      bannerEnd = shade(c, 0.13)
  style.textContent = [
    //横幅渐变:!important压过scoped兜底与旧静态样式
    '.profile-banner{background:linear-gradient(135deg,'+c+' 0%,'+bannerEnd+' 100%) !important;}',
    //primary常态与悬停/聚焦
    '.el-button--primary,.el-button--primary:focus,.el-button--primary:hover{background-color:'+c+' !important;border-color:'+c+' !important;color:#fff !important;}',
    '.el-button--primary:active{background-color:'+active+' !important;border-color:'+active+' !important;color:#fff !important;}',
    '.el-button--primary.is-disabled,.el-button--primary.is-disabled:focus,.el-button--primary.is-disabled:hover,.el-button--primary.is-disabled:active{background-color:'+disabled+' !important;border-color:'+disabled+' !important;color:#fff !important;}',
    //plain变体
    '.el-button--primary.is-plain{color:'+c+' !important;background:'+plainBg+' !important;border-color:'+plainBorder+' !important;}',
    '.el-button--primary.is-plain:focus,.el-button--primary.is-plain:hover{background:'+c+' !important;border-color:'+c+' !important;color:#fff !important;}',
    '.el-button--primary.is-plain:active{background:'+active+' !important;border-color:'+active+' !important;color:#fff !important;}',
    '.el-button--primary.is-plain.is-disabled{color:'+plainDisabled+' !important;background:'+plainBg+' !important;border-color:'+plainBg+' !important;}',
    //text变体
    '.el-button--text{color:'+c+' !important;}',
    '.el-button--text:focus,.el-button--text:hover{color:'+hover+' !important;}',
    '.el-button--text:active{color:'+active+' !important;}',
    '.el-button--text.is-disabled,.el-button--text.is-disabled:focus,.el-button--text.is-disabled:hover{color:'+disabled+' !important;}'
  ].join('')
}

export function initSkin(){
  applySkin(getSkin())
}



// WEBPACK FOOTER //
// ./src/utils/skin.js